import { render, staticRenderFns } from "./academic_examination_ftpaper.vue?vue&type=template&id=156e2d1c&scoped=true&"
import script from "./academic_examination_ftpaper.vue?vue&type=script&lang=js&"
export * from "./academic_examination_ftpaper.vue?vue&type=script&lang=js&"
import style0 from "./academic_examination_ftpaper.vue?vue&type=style&index=0&id=156e2d1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156e2d1c",
  null
  
)

export default component.exports